import { FC } from 'react'
import s from './QuickBookingArticle.module.sass'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { Button } from '@shared/ui/Actions/Button'
import Link from '@shared/ui/Navigation/Link'
import { TypeMappingRestOutput } from '@shared/api/middleware/mappingAPI/restaurant/type'
import { useBookingClick } from '@widgets/Restaurant/Booking/lib/useBookingClick'
import { isBookingAvailable } from '@shared/lib/booking/domain/providerRegistry'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { EGG } from '@shared/api/analytics'

interface Props {
  restData: TypeMappingRestOutput
  className?: string
}

const QuickBookingArticle: FC<Props> = ({ restData, className = '' }) => {
  const { isMobile } = useClientResponsive()
  const handleBookingClick = useBookingClick({ restData })

  const hasBooking = isBookingAvailable(restData?.booking)
  if (!hasBooking) return

  const handleBooking = () => {
    handleBookingClick()
    EGG.entity.booking.buttons_quick_booking_booking_click(restData, { section_index: 0 })
  }
  const handleNavigate = () => {
    EGG.entity.booking.buttons_quick_booking_booking_click(restData, { section_index: 0 })
  }

  return (
    <BlockBoundary>
      <div className={`${s.widget} ${className}`}>
        <Button sizes={'XL L'} mode={'black'} onClick={handleBooking}>
          Забронировать
        </Button>

        <Link href={restData.url.path} target={'_blank'} className={s.link} onClick={handleNavigate}>
          <Button sizes={'XL L'} mode={'white-border'}>
            Подробнее {isMobile ? '' : 'о ресторане'}
          </Button>
        </Link>
      </div>
    </BlockBoundary>
  )
}

export default QuickBookingArticle
